import { isMobile } from 'is-mobile';
import { last } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';
import { Injectable, OnInit } from "@angular/core";
import { BannersClient, Baners } from "../api/WickedApiClient";

@Injectable({
  providedIn: "root"
})

export class bannerZoneServices
{
  private _userBaners:Array<Baners> = [];
  private _userBanersIsReady:ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

 

  public userBanerIsChecked: boolean = false;

  get userBaners(){
    return this._userBaners;
  }

  get userBanersIsReady$() {
    return this._userBanersIsReady.asObservable();
  }

  public addUserBaner(baner: Baners) {
    this._userBaners.push(baner)
  }

  public removeUsedBanerFromList(banerIndex) {
    this._userBaners.splice(banerIndex,1);
  }

  constructor(private banersClient: BannersClient) {}

  //user baners compability
  public getAllUserBaners(isMobile: number = 0): Promise<Array<Baners>> {

    return new Promise<Array<Baners>>((resolve, reject) => {
        this.banersClient.getAllUserBaners(isMobile).subscribe(response => {
        
            this._userBaners = response;
            this._userBanersIsReady.next(true);
            resolve(response);
        });
    });

  }
  
}

export interface IBanner
{
  image:string;
  target:string;
  type:advType;
  id:number;
}

export enum advType
{
  HORIZONTAL,
  VERTICAL
}
